import { render, staticRenderFns } from "./UserHistory.vue?vue&type=template&id=f16b1c1e&"
import script from "./UserHistory.vue?vue&type=script&lang=js&"
export * from "./UserHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserHistory.vue?vue&type=style&index=0&lang=css&"
import style1 from "spinkit/scss/spinkit.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserHistory.vue"
export default component.exports